import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

/** Accepts nxivo-admin launch tokens and exchanges them for a Bindley session. */
export default function AuthCallbackPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { completeOAuthLogin } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const accessToken = params.get("accessToken");
    if (!accessToken) {
      setError("Missing access token");
      return;
    }
    const configured = (process.env.REACT_APP_BACKEND_URL || "").trim();
    const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);
    const backend = (configured || (isLocal ? "http://localhost:8001" : window.location.origin)).replace(/\/+$/, "");
    const apiBase = `${backend}/api`;
    (async () => {
      try {
        const res = await fetch(`${apiBase}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            accessToken,
            refreshToken: params.get("refreshToken"),
          }),
        });
        const body = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(body.detail || body.message || "Session failed");
        await completeOAuthLogin(body.token, body.user);
        toast.success("Signed in via Nxivo");
        nav("/", { replace: true });
      } catch (e) {
        setError(e instanceof Error ? e.message : "Auth failed");
      }
    })();
  }, [params, nav, completeOAuthLogin]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center p-6 text-destructive">
        {error}
      </div>
    );
  }
  return (
    <div className="flex min-h-screen items-center justify-center p-6 text-muted-foreground">
      Signing you into Bindley…
    </div>
  );
}
